import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler, paramsFieldNamingHandler } from '../../../base/decorators';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { getFormDataWithParams } from '../../../base/utils';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { ADD_INDEPENDENT_PWD, CHECK_PWD_QUESTION, CHECK_VERIFY_CODE, DEL_INDEPENDENT_PWD, GET_PWD_QUESTION, GET_PWD_TIPS, GET_VERIFY_CODE, RESET_INDEPENDENT_PWD, TOKEN_VERIFY, VERIFY_INDEPENDENT_PWD, } from './cgi-path';
var PasswordRepository = /** @class */ (function () {
    function PasswordRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    PasswordRepository.prototype.pwdAdd = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, params));
                return [2 /*return*/, this.networkRequestService.instance.post(ADD_INDEPENDENT_PWD, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdDel = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, this.changeParam(params)));
                return [2 /*return*/, this.networkRequestService.instance.post(DEL_INDEPENDENT_PWD, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdVerify = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, params));
                return [2 /*return*/, this.networkRequestService.instance.post(VERIFY_INDEPENDENT_PWD, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdReset = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, this.changeParam(params)));
                return [2 /*return*/, this.networkRequestService.instance.post(RESET_INDEPENDENT_PWD, formData)];
            });
        });
    };
    /**
     * 发送手机验证码到用户输入的手机号
     * @param params
     * @returns
     */
    PasswordRepository.prototype.pwdVerifyCodeGet = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, params));
                return [2 /*return*/, this.networkRequestService.instance.post(GET_VERIFY_CODE, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdVerifyCodeCheck = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, params));
                return [2 /*return*/, this.networkRequestService.instance.post(CHECK_VERIFY_CODE, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdQuestionCheck = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, this.changeParam(params)));
                return [2 /*return*/, this.networkRequestService.instance.post(CHECK_PWD_QUESTION, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdQuestionGet = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                return [2 /*return*/, this.networkRequestService.instance.post(GET_PWD_QUESTION, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdTipsGet = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                return [2 /*return*/, this.networkRequestService.instance.post(GET_PWD_TIPS, formData)];
            });
        });
    };
    PasswordRepository.prototype.pwdTokenVerify = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networkRequestService.instance.post(TOKEN_VERIFY, __assign({ xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }, params))];
            });
        });
    };
    PasswordRepository.prototype.changeParam = function (params) {
        if (params.question_info) {
            return __assign(__assign({}, params), { question_info: JSON.stringify(params.question_info) });
        }
        return params;
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdAdd", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdDel", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdVerify", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdReset", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdVerifyCodeGet", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdVerifyCodeCheck", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdQuestionCheck", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdQuestionGet", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdTipsGet", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PasswordRepository.prototype, "pwdTokenVerify", null);
    PasswordRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], PasswordRepository);
    return PasswordRepository;
}());
export { PasswordRepository };
